<template>
    <section class="related-links-group">

        <header v-if="group.Name || collapsible || $slots.actions || $slots.title"
            class="related-links-group__header"
            :class="{ 'is-collapsible': collapsible }"
            @click="handleHeaderClick">
            
            <button v-if="collapsible"
                    type="button"
                    class="related-links-group__toggle"
                    :aria-expanded="expanded"
                    @click.stop="$emit('toggle')">
                <span aria-hidden="true">
                    <i :class="expanded ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-right'" aria-hidden="true"></i>
                </span>

                <span class="sr-only">
                    {{ expanded ? 'Collapse' : 'Expand' }}
                </span>
            </button>

            <div class="related-links-group__title">
                <slot name="title" :group="group">
                    <h3 v-if="group.Name">
                        {{ group.Name }}
                    </h3>
                </slot>
            </div>

            <div v-if="$slots.actions"
                 class="related-links-group__actions">
                <slot name="actions" :group="group" />
            </div>
        </header>

        <div class="related-links-group__before-links">
            <slot name="before-links" :group="group" />
        </div>

        <draggable v-show="!collapsible || expanded"
                   :list="group.Links"
                   item-key="Id"
                   tag="ul"
                   class="related-links-group__links"
                   :disabled="!draggableLinks"
                   :group="{ name: dragGroupName, pull: true, put: true }"
                   handle=".related-links-admin__link-drag-handle"
                   ghost-class="related-links-admin__drag-ghost"
                   chosen-class="related-links-admin__drag-chosen"
                   drag-class="related-links-admin__dragging"
                   @choose="$emit('link-drag-choose', group, $event)"
                   @start="$emit('link-drag-start', group, $event)"
                   @end="$emit('link-drag-end', group, $event)"
                   @add="linkAdded">

            <template #item="{ element }">
                <li class="related-links-group__link-item">
                    <slot name="link"
                          :group="group"
                          :link="element">
                        <RelatedLinkItem :link="element" />
                    </slot>
                </li>
            </template>

        </draggable>

        <div class="related-links-group__after-links">
            <slot name="after-links" :group="group" />
        </div>

    </section>

</template>

<script setup>
    import draggable from 'vuedraggable';
    import RelatedLinkItem from './RelatedLinkItem.vue';

    const props = defineProps({
        group: {
            type: Object,
            required: true
        },

        collapsible: {
            type: Boolean,
            default: false
        },

        expanded: {
            type: Boolean,
            default: true
        },

        draggableLinks: {
            type: Boolean,
            default: false
        },

        dragGroupName: {
            type: String,
            default: 'related-links'
        }
    });

    const emit = defineEmits([
        'toggle',
        'link-drag-choose',
        'link-drag-start',
        'link-drag-end',
        'link-added'
    ]);

    function linkAdded(event) {
        const link = props.group.Links[event.newIndex];

        emit('link-added', props.group, link, event.newIndex);
    }

    function handleHeaderClick(event) {
        if (!props.collapsible) {
            return;
        }

        if (event.target.closest('button, a, input, textarea, select, form')) {
            return;
        }

        emit('toggle');
    }
</script>